/**
 * Determines Flow Type For Results/SEO Pages
 * @param {object} opts
 * @param {boolean} opts.isState
 * @param {boolean} opts.isCity
 * @param {boolean} opts.isPhone
 * @param {boolean} opts.isAddress
 * @returns {string}
 */
const determineFlowType = (opts = {}) => {
  if (opts.isState) {
    return 'state';
  }
  if (opts.isCity) {
    return 'city';
  }
  if (opts.isPhone) {
    return 'phone';
  }
  if (opts.isAddress) {
    return 'address';
  }
  return 'root';
};

export default determineFlowType;
